import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const alphabet = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            hero: {
                ...de_DE_formal.translation.hero,
                ...{
                    'title': 'Willkommen bei der Werkstatt-Buchung von {{organization}}',
                    'subtitle': null,
                }
            },
            welcomeModal: {
                ...de_DE_formal.translation.welcomeModal,
                ...{
                    'title': null,
                    'text': null,
                }
            },
        },
    }
}
